import React from 'react'

import ArrowIcon from 'core/components/icons/ArrowIcon'

const PressList = props => {
  return (
    <div className="press-list">
      {props.items.map((item, index) => (
        <article key={index} className="press-list-item">
          <div className="press-list-item-text">
            <h1 className="press-list-item-title">
              <a className="press-list-item-link" href={item.fields.article_link} target="_blank">
                {item.post_title}
              </a>
            </h1>
            <div className="press-list-item-meta">
              <span
                className="press-list-item-meta-detail mod-type mod-clickable"
                onClick={e => props.toggleFilter(e, item.fields.article_type.toLowerCase())}
              >
                {item.fields.article_type}
              </span>
              <span className="press-list-item-meta-detail mod-organization">
                {item.fields.outlet}
              </span>
              <span className="press-list-item-meta-detail mod-date">{item.post_date}</span>
            </div>
          </div>
          <div className="press-list-item-view">
            <a
              className="press-list-item-link mod-view"
              href={item.fields.article_link}
              target="_blank"
            >
              View
              <ArrowIcon />
            </a>
          </div>
        </article>
      ))}
    </div>
  )
}

export default PressList
